import React from 'react';
import { create } from 'jss';
import { ThemeProviderV4, StyledEngineProvider, StylesProviderV4, jssPreset, ThemeProvider } from '~/lib/bn-material-ui';
import { muiTheme, generateClassName } from '~/utility/BinSentry-ui-utility';
import BinLevelUnmonitored from '../../bins/bin-level/bin-unmonitored';

export function unmonitoredBinLevel(props) {
  const jss = create({
    ...jssPreset(),
    // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
    insertionPoint: props.insertionPoint,
  });

  return (
    <StyledEngineProvider generateClassName={generateClassName} injectFirst>
      <StylesProviderV4 generateClassName={generateClassName} jss={jss}>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderV4 theme={muiTheme}>
            <BinLevelUnmonitored href={props.href} standAlone={props.standAlone} />
          </ThemeProviderV4>
        </ThemeProvider>
      </StylesProviderV4>
    </StyledEngineProvider>
  );
}
